export default "__VITE_ASSET__C5_87SV7__"